import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  Input,
  FormFeedback,
  Spinner,
  FormGroup,
} from "reactstrap";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCheckEmailMutation } from "../../../services/auth/api";
import toast from "react-hot-toast";
import ToastNotification from "components/Toast/ToastNotification";
import slash from "assets/icons/slash-circle.svg";
import { useNavigate } from "react-router-dom";

const ForgotPasswordForm = ({ onSuccess }) => {
  const [checkEmail] = useCheckEmailMutation();
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("รูปแบบอีเมลไม่ถูกต้อง")
        .required("กรุณากรอกอีเมล"),
    }),
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        const result = await checkEmail(values);

        if (result.data.data?.exists) {
          onSuccess({ email: values.email });
        } else {
          setFieldError("email", "ไม่พบอีเมลนี้ในระบบ");
          let id = toast.custom(
            <ToastNotification variant="danger" icon={slash} title="ไม่พบอีเมล" description="เราได้ทำการตรวจสอบแล้ว ไม่พบอีเมลนี้ในระบบ" onSecondaryClick={() => toast.dismiss(id)} />,
            { position: "top-right", duration: 5000 }
          );
        }
      } catch (error) {
        setFieldError("email", "ไม่พบอีเมลนี้ในระบบ");
        let id = toast.custom(
          <ToastNotification variant="danger" icon={slash} title="ไม่พบอีเมล" description="เราได้ทำการตรวจสอบแล้ว ไม่พบอีเมลนี้ในระบบ" onSecondaryClick={() => toast.dismiss(id)} />,
          { position: "top-right", duration: 5000 }
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Card className="card-auth">
      <CardTitle className="text-center">
        <h1 className="text-4xl fw-semibold">ลืมรหัสผ่าน</h1>
      </CardTitle>
      <CardBody>
        <Form
          className="w-full"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <h4 className="text-center text-gray-500 mb-4">
            กรุณากรอกอีเมลที่ใช้สมัครสมาชิก <br />
            ระบบจะส่งลิงก์สำหรับรีเซ็ตรหัสผ่านไปให้คุณ
          </h4>
          <FormGroup className="space-y-4">
            <div className="form-horizontal w-full d-flex flex-column gap-4">
              <div>
                <Input
                  name="email"
                  type="email"
                  className="form-control form-control-lg"
                  placeholder="อีเมล"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  disabled={validation.isSubmitting}
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                />
                {validation.touched.email && validation.errors.email && (
                  <FormFeedback type="invalid">
                    {validation.errors.email}
                  </FormFeedback>
                )}
              </div>
            </div>

            <div className="w-full">
              <Button
                type="submit"
                color="primary"
                size="lg"
                className="py-2 w-full"
                disabled={!validation.isValid || validation.isSubmitting}
              >
                {validation.isSubmitting ? (
                  <>
                    <Spinner size="sm" />
                    กำลังดำเนินการ...
                  </>
                ) : (
                  "ยืนยัน"
                )}
              </Button>
            </div>
          </FormGroup>

          <div className="d-flex justify-center items-center text-center mt-4">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
              className="link"
            >
              กลับไปหน้าเข้าสู่ระบบ
            </a>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
};

ForgotPasswordForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default ForgotPasswordForm;
